module.exports = "/images/actionArrow.png?5a5b51e56586ea7b76343ca8441d4f4c";